import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import type { RulesExtend } from '@ackee/fela';

import type { BlogPost } from 'modules/blog/types';

import { BlogPostCard } from '../BlogPostCard';

import * as felaRules from './BlogPostsList.rules';

export interface BlogPostsListProps {
    posts: BlogPost[];
    extend?: RulesExtend<typeof felaRules>;
    languageMutation?: undefined | 'en' | 'cs' | 'de';
}

export const BlogPostsList = ({ posts, extend, languageMutation = undefined }: BlogPostsListProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules, { extend });

    return (
        <div className={styles.posts}>
            {posts.map(post => (
                <BlogPostCard
                    key={post.title}
                    {...post}
                    extend={{ post: rules.post }}
                    languageMutation={languageMutation}
                />
            ))}
        </div>
    );
};
